module.exports = __webpack_public_path__ + "img/SKMJ_nofood.e8ed03b0.png";